jQuery(document).ready(function ($) {

    let productFormBar = $(".wbp-full-info");
    let productFormBarInner = $('.wbp-full-info .product-single__meta');
    let productFormTrigger = $(".wbp-stuck-trigger");
    let productFormStuck = $('.wbp-full-info .wbp_info, .wbp-full-info .wbp_info-right .product-block.variants, .wbp-full-info .product-block.quantity, .wbp-full-info .wbp_info-right .product-block--price, .wbp-full-info .buy-buttons .product__policies, .wbp-full-info .promo-messages');
    let productFormStuckButton = $('.wbp-fake-button');

    $('.wbp-full-info-button').click(function(){
        $('.wbp-full-info.stuck .product-single__meta').slideToggle();
        $(this).toggleClass("closed");
    });

    $('.wbp_info-right .order-info-button').click(function (){
        $(this).toggleClass('open');
        $('.wbp_info-right .order-info-dropdown').toggle().toggleClass('open');
    });

    $(".ProductImageGrid").css("--height", $(".wbp-full-info").height() + "px");
    $(window).on('resize', function() {
        $(".ProductImageGrid").css("--height", $(".wbp-full-info").height() + "px");
    });

    $(window).on("scroll", () => {
        if ($(window).scrollTop() <= productFormTrigger.offset().top) {
            $(".ProductImageGrid").css("--height", $(".wbp-full-info").height() + "px");
            productFormBar.removeClass('stuck').show();
            productFormBarInner.show();
            productFormBar.parent().removeClass('fakeDiv');
            productFormStuckButton.removeClass('open');
            productFormStuck.removeClass('open');
            $('.wbp-full-info-button').removeClass('closed');
        } else {
            productFormBar.addClass('stuck');
            productFormBar.parent().addClass('fakeDiv');
            productFormStuckButton.click(function(){
                $(this).addClass('open');
                productFormStuck.addClass('open');
            });
            $(document).mouseup(function(e){
                var container = productFormStuck;
                if (!container.is(e.target) && container.has(e.target).length === 0){
                    productFormStuckButton.removeClass('open');
                    container.removeClass('open');
                }
            });
        }
    });
    
});